import { createSelector } from 'reselect'
import getRouteAndMatchRouterSelect from 'modules/router/selectors/get-route-and-match/index.js'
import hasGymaholicHeaderRouteUtil from 'modules/routes/utils/has-gymaholic-header/index.js'

const shouldHideHeaderRouterSelect = createSelector(
  getRouteAndMatchRouterSelect,
  (routeAndMatch) => {
    return !hasGymaholicHeaderRouteUtil(routeAndMatch?.route?.path)
  }
)

export default shouldHideHeaderRouterSelect
